import {
  object, string, boolean, date,
} from 'yup';

import { COMMENT_TYPES } from './comment.constants';

const commentSchema = object({
  id: string(),
  created_on: date().required(),
  created_by: string().nullable().default(null),
  updated_on: date().required(),

  audit_id: string().nullable().default(null),

  task_id: string().nullable().default(null),
  document_id: string().nullable().default(null),

  type: string().oneOf(Object.values(COMMENT_TYPES)).required(),

  content: string().nullable().default(null),

  is_need_resolve: boolean().default(false),
  resolved_by: string().nullable().default(null),
  resolved_on: date().nullable(),
});

export default commentSchema;
